<template>
  <div>
    <b-row>
      <b-col> 
        <b-card class="surrounding-card" :style="'background: linear-gradient(to right top, #5f135f 35%, ' + productColor() + ' 52%)'">
          <b-card no-body class="mb-1" style="border-radius: 16px 16px 16px 16px">
            <b-card-header>Current Product</b-card-header>
            <b-card-body>
              <span v-if="!activeproduct">This account does not have an active product.</span>
              <span v-if="activeproduct">This account is currently on the {{activeproduct.name}} product tier.</span><br />
              <span v-if="!subscription && activeuntil">The credit on this account will expire on {{ new Date(activeuntil).toDateString() }}.</span>
              <span v-if="subscription">Your credit for the {{activeproduct.name}} product tier will expire on {{activeuntil.toDateString()}}.</span><br v-if="subscription" />
              <span v-if="subscription">This expiration date does not apply to your {{plan.name}} subscription, which will renew on {{new Date(subscription.nextPaymentDate).toDateString()}}.</span>
            </b-card-body>
          </b-card>
        </b-card>
      </b-col>
      <b-col> 
        <b-card class="surrounding-card" :style="'background: linear-gradient(to right top, #5f135f 35%, ' + productColor() + ' 52%)'">
          <b-card no-body class="mb-1" style="border-radius: 16px 16px 16px 16px">
            <b-card-header>Current Connection Status</b-card-header>
              <b-card-body>
              You are <span v-if="! onnet">not</span> currently on a SoldierNET network.
              <span v-if="onnet">This device is <span v-if="!connected">not</span> connected to the Internet.
              The device is not registered and has not connected. You can turn on the internet 
              <!-- <connect-switch></connect-switch> -->
              </span>
            </b-card-body>
          </b-card>
        </b-card>
      </b-col>
    </b-row>
    <b-row>
      <b-col> 
        <b-card class="surrounding-card" :style="'background: linear-gradient(to right top, #5f135f 35%, ' + productColor() + ' 52%)'">
          <b-card no-body class="mb-1" style="border-radius: 16px 16px 16px 16px">
            <b-card-header>Billing/Subscription  (..manage)</b-card-header>
            <b-card-body>
              <span v-if="subscription">This account has an active subscription. The next payment of £xx will be taken on {{new Date(subscription.nextPaymentDate).toDateString()}} for the {{plan.name}} product plan.</span>
              <span v-else>This account does NOT an active subscription</span>                    
            </b-card-body>
          </b-card>
        </b-card>
      </b-col>
      <b-col> 
        <b-card class="surrounding-card" :style="'background: linear-gradient(to right top, #5f135f 35%, ' + productColor() + ' 52%)'">
          <b-card no-body class="mb-1" style="border-radius: 16px 16px 16px 16px">
            <b-card-header>Devices</b-card-header>
            <b-card-body>
              <span v-if="devices.length > 0">You have registered {{ devices.length}} devices. <router-link to="account/devices">(more info...)</router-link>.</span>
              <span v-else>You have not registered any devices yet.</span>
              <span v-if="activeproduct">Your {{activeproduct.name}} plan will connect the first {{activeproduct.devices}} registered devices and you can still 
              connect with another device by logging in with the account username/password.</span>
            </b-card-body>
          </b-card>
        </b-card>
      </b-col>
     </b-row>
  </div>
</template>

<script>
import { mapState, mapGetters } from 'vuex';
// import ConnectSwitch from '../../components/captive/ConnectSwitch.vue'

export default {
  name: 'Dashboard',
  // components: {
  //   ConnectSwitch
  // },
  data: () => ({
    devices: [],
    // subscription: undefined,
    connected: false
  }),
  computed: {
    ...mapState('captive', ['onnet']),
    ...mapGetters({
      products: 'pricing/getProducts',
      prices: 'pricing/getPrices',
      selectedProduct: 'pricing/getChosenProduct',
      selectedPeriod: 'pricing/getChosenPeriod',
      // adjustedPrices: 'pricing/getPriceAdjustments',
      special: 'pricing/getSpecial',
      subscription: "plan/getSubscription",
      activeproduct: 'plan/getActiveProduct',
      activeuntil: 'plan/getActiveUntil'
    }),
    plan() {
      return this.products.find((product) => product.productid === this.subscription.product.productid)
    }
  },  
  methods: {
    checkDevices(){
      this.$portalapi
        .get("/myaccount/devices")
        .then((response) => {
          this.devices = response.data;
        })
        .catch((error) => {
          this.$log.onDebug("error fetching devices");
        });
    },
    // checkSubscription(){
    //   this.$portalapi
    //     .get("/myaccount/subscription")
    //     .then((response) => {
    //       if ( response.data)
    //         this.subscription = response.data;
    //       else
    //         this.subscription = undefined
    //     })
    //     .catch((error) => {
    //       this.$log.onError("unable to fetch subscription." + error);
    //     });
    // },
    productColor() {
      if (this.subscription != null) {
        switch (this.subscription.product.productid) {
          case 1: return '#38AADE'
          case 2: return '#EE811A'
          case 3: return '#5DB12F'
          case 4: return '#ccba78'
          case 5: return '#ccba78'
          default: return '#471747'
        }
      }
      else return '#471747'
    
    },
  },
  mounted: function () {
    this.$store.dispatch("plan/initialiseSubscription")

    this.checkDevices()

    // this.checkSubscription()
    
  },
  
}
</script>


<style lang="scss" scoped>

.product-card {
  border-radius: 16px 16px 16px 16px;
}

legend {
  font-weight: bold;
  padding: 0rem;
  padding-left: 1rem;
  padding-right: 1rem;
  width: fit-content;
}

.surrounding-card {
  border-radius: 16px 16px 16px 16px;
  box-shadow: 28px 24px 12px 6px grey;
  border: none;
}

.account-field {
  border: 1px black solid;
  padding: 2rem 2rem 1rem 2rem;
  border-radius: 14px 14px 14px 14px;
  // color: #471747; orig
  // color: #5f135f;
}

</style>